import * as t from 'io-ts';
import { AircraftDynamicType } from './aircraft';
import { AirportDetailsDynamicType } from './airport';
import { ItineraryAdditionalInformationDynamicType } from './itineraryAdditionalInformation';
import { PassengerDynamicType } from './passenger';
import { BrokerShortDetailsDynamicType } from './brokerDetails';
import { LegDynamicType } from './leg';
import { CrewMemberDynamicType } from './crewMember';

export const ItineraryLegDynamicType = t.interface({
    id: t.string,
    aircraft: AircraftDynamicType,
    flightNumber: t.string,
    airports: t.array(AirportDetailsDynamicType),
    additionalInformation: ItineraryAdditionalInformationDynamicType,
    passengers: t.array(PassengerDynamicType),
    crewMembers: t.array(CrewMemberDynamicType),
    flightManager: t.union([BrokerShortDetailsDynamicType, t.null]),
    leg: LegDynamicType
});

export type ItineraryLeg = t.TypeOf<typeof ItineraryLegDynamicType>;
